<template>
	<div :class="`notification-main ${notifClosed ? 'hidden' : ''}`">
		<div class="container-modal" v-if="corner">
			<CornerNotification :text="notifText" :title="notifTitle" :type="notifType" :corner="corner" @close="close" />
		</div>

		<div class="container-block" v-else>
			<BlockNotification :text="notifText" :title="notifTitle" :type="notifType" @close="close" />
		</div>
	</div>
</template>

<script>
import CornerNotification from './CornerNotification'
import BlockNotification from './BlockNotification'

export default {
	name: 'Notification',
	props: {
		text: String,
		title: String,
		type: String,
		corner: String,
		closed: Boolean,
		timer: Number
	},
	data () {
		return {
			notifText: this.text,
			notifTitle: this.title,
			notifType: this.type,
			notifClosed: this.closed,
			notifTimer: this.timer || 5000,
			notifTimeout: null
		}
	},
	components: { CornerNotification, BlockNotification },
	mounted () {
		window.notificationEM = this
	},
	destroyed () {
		window.notificationEM = null
	},
	methods: {
		open (title, text, type) {
			this.$el.classList.remove('hidden')
			this.notifTitle = title
			this.notifText = text
			this.notifType = type
			this.notifClosed = false

			if (this.corner) {
				if (this.notifTimeout) {
					clearTimeout(this.notifTimeout)
				}

				if (this.notifTimer > 0) {
					this.notifTimeout = setTimeout(() => this.close(), this.notifTimer)
				}
			}
		},
		close () {
			this.$el.classList.add('hidden')
			this.notifClosed = true
		}
	}
}
</script>

<style lang="scss" scoped>
	.notification-main.hidden {
		display: none;
	}
</style>
